<template>
  <v-menu offset-x :nudge-right="16" transition="slide-x-transition" :min-width="240">
    <template #activator="{ on }">
      <NavItem icon="trending_up" label="Analytics" v-on="on" />
    </template>

    <v-card>
      <v-list>
        <v-list-item
          v-for="availableRoute in availableRoutes"
          :key="availableRoute.key"
          :to="availableRoute.to"
          ripple
        >
          <v-list-item-content>
            <v-list-item-title>{{ availableRoute.label }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script setup lang="ts">
import NavItem from '@/components/nav/NavItem.vue'
import { useGetDashboardsQuery } from '@/api/dashboards'
import { computed, onMounted } from 'vue'

const { data: dashboards, refetch } = useGetDashboardsQuery()

const availableRoutes = computed(
  () =>
    dashboards.value?.map((dashboard) => ({
      label: dashboard.name,
      to: `/analytics/dashboards/${dashboard.id}`,
      key: `${dashboard.id}-${dashboard.name}`,
    })) ?? [],
)

onMounted(() => {
  refetch()
})
</script>
